import { afterNextPaint } from '@helpers/after-next-paint';
import {
	isPricingInSidebarAtom,
	selectedSidebarFiltersAtom,
	selectedSidebarFiltersCountAtom,
} from '@pages/VendorsSearch/containers/FilterPills/components/Sidebar/atoms';
import { Link } from '@tkww/orion-web-ds-action';
import { useAtomValue, useSetAtom } from 'jotai';
import React from 'react';
import { useStartingPriceFilter } from '../../StartingPriceFilter/use-starting-price-filter';
import Styles from './styles.scss';

const MobileHeader = () => {
	const { clear } = useStartingPriceFilter();
	const setSelectedSidebarFilters = useSetAtom(selectedSidebarFiltersAtom);
	const selectedFilterCount = useAtomValue(selectedSidebarFiltersCountAtom);
	const isPricingInSidebar = useAtomValue(isPricingInSidebarAtom);
	const onClickClearAll = () => {
		afterNextPaint(() => {
			setSelectedSidebarFilters([]);
			// price shares its atoms with a pill rendered outside the sidebar;
			// only clear it here if this category actually manages it in-sidebar
			if (isPricingInSidebar) {
				clear();
			}
		});
	};
	return (
		<div className={Styles.mobileHeaderContainer}>
			{selectedFilterCount > 0 && (
				<Link
					as="button"
					className={Styles.clearAllLink}
					onClick={onClickClearAll}
					type="button"
				>
					Clear All
				</Link>
			)}{' '}
			<h4>
				More filters{selectedFilterCount > 0 ? ` (${selectedFilterCount})` : ''}
			</h4>
		</div>
	);
};

export default MobileHeader;
